import { render, staticRenderFns } from "./ChartVestingUnlocks.vue?vue&type=template&id=1bde1aa0"
import script from "./ChartVestingUnlocks.vue?vue&type=script&lang=js"
export * from "./ChartVestingUnlocks.vue?vue&type=script&lang=js"
import style0 from "./ChartVestingUnlocks.vue?vue&type=style&index=0&id=1bde1aa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports